// test2079
(2079 && 0);
